import React from "react";

const Button = (props) => {
  return (
    <>
      <button
        className='btn'
        style={{
          color: "white",
          width: "100%",
          height: "48px",
          backgroundColor: "#137CCE",
          fontWeight: "600",
          borderRadius: "24px" /* Rounded: 12px subtle, 24px pill-shaped */
        }}
        onClick={props.onClick}
        disabled={props.disabled}
        type={props.type}
        value={props.value}
      >
        {props.text}
      </button>
    </>
  );
};

export default Button;
